import type { Locale } from '@skytech/types'
import { DEFAULT_LOCALE, getLocalDate } from '@skytech/utils'

import { useObject } from './object'
import useSetup from './setup'

export const useLocalDate = () => {
  const setup = useSetup()
  const object = useObject()

  const formatDate = ({ date, locale }: { date: string | Date | null; locale?: Locale }) =>
    getLocalDate({
      date,
      locale: locale || object?.locale || setup?.locale || DEFAULT_LOCALE,
    })

  return { formatDate }
}
